import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { ValueType } from 'react-select';
import { Dispatch } from 'redux';
import { RootState } from '../../stores/store';
import { removeFilter, setFilter } from '../../stores/tables/actionCreators';
import { getFilter } from '../../stores/tables/selectors';
import { TableFilter } from '../../stores/tables/state';
import ConfirmModal from '../common/modals/ConfirmModal';
import MultiSelect from '../common/MultiSelect';
import TableColumn from './TableColumn';

interface SelfProps {
    tableKey: string;
    filterKey: string;
    columnName: string;
    options: Array<{ label: string, value: string }>;
    refresh: () => void;
}

interface Props extends LocalizeContextProps, SelfProps {
    filter?: TableFilter;

    setFilter: (selection: string[]) => void;
    removeFilter: () => void;
}

interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
}

class TableFilterableColumn extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: undefined,
            showModal: false,
        };
    }
    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                <TableColumn
                    className="filterable clickable"
                    onClick={this.openFilter}
                >
                    <span>{this.props.columnName}</span>
                    <FontAwesomeIcon
                        className="ml-2"
                        icon={this.props.filter && this.props.filter.length > 0 ? ['fas', 'filter'] : ['fal', 'filter']}
                    />
                </TableColumn>
                <ConfirmModal
                    bodyHeight="300px"
                    header={t('modal.filter') + this.props.columnName}
                    confirmText={t('modal.apply') as string}
                    isOpen={this.state.showModal}
                    confirm={() => {
                        this.setFilter();
                    }}
                    cancel={() => { this.setState({ showModal: false }); }}
                >
                    <MultiSelect
                        className={"dropdown-select table-filter-select"}
                        options={this.props.options}
                        value={this.state.selection}
                        onChange={this.handleSelectChange}
                    />
                </ConfirmModal>
            </React.Fragment>
        );
    }

    private setFilter = () => {
        if (this.state.selection && Array.isArray(this.state.selection) && this.state.selection.length > 0) {
            this.props.setFilter(this.state.selection.map((option) => option.value));
        } else {
            this.props.removeFilter();
            this.setState({ selection: undefined });
        }
        this.props.refresh();
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        this.setState({ selection: (val === null || val === undefined) ? [] : val });
    }

    private openFilter = () => {
        if (this.props.filter && this.props.filter.length > 0) {
            this.setState({
                selection: this.props.options.filter((option) =>
                    this.props.filter?.find((id) => option.value === id)),
                showModal: true,
            });
        } else {
            this.setState({ showModal: true });
        }
    }
}

const mapStateToProps = (state: RootState, props: SelfProps) => ({
    filter: getFilter(state, props.tableKey, props.filterKey),
});

const mapDispatchToProps = (dispatch: Dispatch, props: SelfProps) => ({
    removeFilter: () =>
        dispatch(removeFilter(props.tableKey, props.filterKey)),
    setFilter: (selection: string[]) =>
        dispatch(setFilter(props.tableKey, props.filterKey, selection)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(TableFilterableColumn));